import { createContext } from 'react';
import initialCatalogGenericsState from './initialCatalogGenericsState';

const CatalogGenericContext = createContext(initialCatalogGenericsState);

export default CatalogGenericContext;
